import { z } from 'zod';

// biz-specs/project-scaffold.md §4.3 — projectName/groupId/domainRoot 는 zip 엔트리·패키지·
// 파일 경로에 직접 반영되므로 정규식 화이트리스트로 엄격 제한(경로 traversal `..`/`/` 등 배제).
// BE 검증(jakarta @Pattern)과 동일 정규식으로 FE 이중 방어.
const PROJECT_NAME_PATTERN = /^[a-z][a-z0-9-]{1,49}$/;
const DOMAIN_PATTERN = /^[a-z][a-z0-9.]{1,99}$/;
// biz-specs/project-scaffold.md §R671-2(a) — sampleFeature 는 패키지·클래스·테이블명·파일 경로에
// 직접 반영되므로 projectName 과 동일 수준의 허용목록(whitelist) 방어(BE @Pattern 과 동일 정규식).
const SAMPLE_FEATURE_PATTERN = /^[a-z][a-z0-9-]{1,49}$/;

export const scaffoldMetaSchema = z
  .object({
    projectName: z
      .string()
      .min(1, '프로젝트명을 입력하세요')
      .regex(PROJECT_NAME_PATTERN, '소문자·숫자·하이픈만 허용됩니다 (경로 문자 금지)'),
    groupId: z
      .string()
      .min(1, '그룹 ID를 입력하세요')
      .regex(DOMAIN_PATTERN, '소문자·숫자·점만 허용되는 역도메인 형식이어야 합니다'),
    domainRoot: z
      .string()
      .min(1, '도메인 루트를 입력하세요')
      .regex(DOMAIN_PATTERN, '소문자·숫자·점만 허용되는 Java 패키지 형식이어야 합니다'),
    // §R671-3(a) — 기본 on. legacy 하위호환은 BE 가 담당(null → false) 이라 FE 기본값은 항상 true 전송.
    includeSample: z.boolean().default(true),
    sampleFeature: z.string().optional(),
    // §R681-3(a) — 기본 off(명시적 opt-in). 조건부 필수 필드 없음(치환은 projectName 뿐).
    includeFrontend: z.boolean().default(false),
    // §R694-5 — 기본 on. 조건부 필수 필드 없음(치환 입력이 projectName/nexusPublicUrl/JDK 뿐).
    includeCiCd: z.boolean().default(true),
  })
  // §R671-3(a) — includeSample===true && !sampleFeature 이면 조건부 필수 오류.
  .superRefine((values, ctx) => {
    if (!values.includeSample) return;
    const feature = values.sampleFeature?.trim();
    if (!feature) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['sampleFeature'], message: '샘플 feature 명을 입력하세요' });
      return;
    }
    if (!SAMPLE_FEATURE_PATTERN.test(feature)) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['sampleFeature'], message: '소문자·숫자·하이픈만 허용됩니다 (경로 문자 금지)' });
    }
  });

export type ScaffoldMetaFormValues = z.infer<typeof scaffoldMetaSchema>;
